//import { render } from 'react-dom';
import './masterdetail.css';
import * as React from 'react';
import { GridComponent, ColumnsDirective, ColumnDirective, Selection, Inject, Page } from '@syncfusion/ej2-react-grids';
import { TabComponent, TabItemDirective, TabItemsDirective } from '@syncfusion/ej2-react-navigations';
//import { customerData, data } from './data_masterdetail';
import { SampleBase } from '../../../syncfusion/sample-base';
import { Query, Predicate, DataManager } from '@syncfusion/ej2-data';
import { CustomWebApiAdaptor} from '../../../_helpers'
import { authenticationService } from '../../../_services'

export class MasterDetail extends SampleBase {
    constructor() {
        super(...arguments);
        this.state = {loading:true};
        this.key = null;
        this.detail = [];
        this.names = ['AROUT', 'BERGS', 'BLONP', 'CHOPS', 'ERNSH'];
        this.tabSelected = 'Marcadores'
        //this.master = customerData.filter((e) => this.names.indexOf(e.CustomerID) !== -1);

        this.maestro = new DataManager({ //url: this.config.HostUrl + CfgOptions[this.props.opcion].puerto + this.config.HostEndUrl + CfgOptions[this.props.opcion].endpoint, 
            url: JSON.parse(sessionStorage.config).HostUrl+'5005/api/v1/man/tablas/proyectos/',
            headers:[{ "Content-Type":  "application / json",
                        "api-token": `${authenticationService.currentUserValue.jwt_token}`
                      }],
            adaptor: new CustomWebApiAdaptor() ,
            timeZoneHandling: false,
            crossDomain: true});  
     
        this.detalleMarcadores = new DataManager({ //url: this.config.HostUrl + CfgOptions[this.props.opcion].puerto + this.config.HostEndUrl + CfgOptions[this.props.opcion].endpoint, 
            url: JSON.parse(sessionStorage.config).HostUrl+'5005/api/v1/man/tablas/marcadores/',
            headers:[{ "Content-Type":  "application / json",
                        "api-token": `${authenticationService.currentUserValue.jwt_token}`
                    }],
            adaptor: new CustomWebApiAdaptor() ,
            timeZoneHandling: false,
            crossDomain: true});  
        
        this.detalleRecursos = new DataManager({ //url: this.config.HostUrl + CfgOptions[this.props.opcion].puerto + this.config.HostEndUrl + CfgOptions[this.props.opcion].endpoint, 
            url: JSON.parse(sessionStorage.config).HostUrl+'5005/api/v1/man/tablas/recursos_proyecto/',
            headers:[{ "Content-Type":  "application / json",
                        "api-token": `${authenticationService.currentUserValue.jwt_token}`
                    }],
            adaptor: new CustomWebApiAdaptor() ,
            timeZoneHandling: false,
            crossDomain: true});  
        
        this.detalle = this.detalleMarcadores;

        console.log(this.maestro);
        console.log(this.detalle);
    }
    ;
    rowselect(args) {
        debugger;
        let selRecord = args.data;
        let selecteMessage = document.getElementsByClassName('e-statustext')[0];
        let message = selecteMessage.querySelector('b');
        message.textContent = selRecord.projectname;
        //this.detailGrid.dataSource = this.detalle.filter((record) => record.projectid === selRecord.projectid).slice(0, 5);
        this.predicateColumns = new Predicate('projectid','equal',selRecord.projectid);
        //this.predicateColumns = this.predicateColumns.and('tabschema','equal',CfgOptions[this.props.opcion].esquema)
        debugger;
        this.setState({loading:true});
        if (this.tabSelected === "Recursos") {
            this.detailGrid.dataSource = this.detalleRecursos.executeQuery(new Query().where(this.predicateColumns).page(1,100))
                                        .then(resp=>{
                                            debugger;   
                                            this.detailGrid.dataSource = resp.actual.data;                         
                                            this.setState({loading:false})
                                            return resp.actual.data;
                                        }); 
        } else {
            this.detailGrid.dataSource = this.detalleMarcadores.executeQuery(new Query().where(this.predicateColumns).page(1,100))
            .then(resp=>{
                debugger;   
                this.detailGrid.dataSource = resp.actual.data;                         
                this.setState({loading:false})
                return resp.actual.data;
            }); 
        }
        
    }
    
    tabContent1(args) {
        debugger;
        this.tabSelected = 'Marcadores';
        return (<div></div>);
    }

    tabContent2(args) {
        debugger;
        this.tabSelected = 'Recursos';
        console.log('Recursos')

        return (<div></div>);
    } 

    

    tabContent3(args) {
        return (<div></div>);
    }

    render() {
        //debugger;
        let headertext;
        // Mapping Tab items Header property
        headertext = [{ text: "Marcadores", 'iconCss': 'e-twitter' },
            { text: "Recursos", 'iconCss': 'e-facebook' }, { text: "WhatsApp", 'iconCss': 'e-whatsapp' }];
        
        return (<div className='control-pane'>
                <div className='control-section'>
                    <GridComponent dataSource={this.maestro} selectedRowIndex={2} rowSelected={this.rowselect.bind(this)} 
                                    allowPaging={true} width={'95%'}
                                    pageSettings={{ pageCount: 3, pageSize: 4, pageSizes: false }}
                                    allowResizing={true}>
                        <ColumnsDirective>
                            <ColumnDirective field='clientid' headerText='ID Cliente' width='50'></ColumnDirective>
                            <ColumnDirective field='projectname' headerText='Nombre del Proyecto' width='150'></ColumnDirective>
                            <ColumnDirective field='startdate' headerText='Fecha Inicio' width='130'/> 
                            <ColumnDirective field='enddate' headerText='Fecha Fin' width='150'/>
                        </ColumnsDirective>
                        <Inject services={[Page, Selection]}/>
                    </GridComponent>

                    <div className='e-statustext'> Proyecto: <b></b>  
                        <div><TabComponent heightAdjustMode='Auto' id='defaultTab' width={'95%'}>
                            <TabItemsDirective>
                            <TabItemDirective header={headertext[0]} content={this.tabContent1.bind(this)}/>

                            <TabItemDirective header={headertext[1]} content={this.tabContent2.bind(this)}/>

                            <TabItemDirective header={headertext[2]} content={this.tabContent3.bind(this)}/>
                            </TabItemsDirective>
                        </TabComponent> </div></div>

                    <GridComponent id='detailGrid' dataSource={[]} allowSelection={false} ref={grid => this.detailGrid = grid} 
                                    allowPaging={true} width={'95%'}
                                    pageSettings={{ pageCount: 3, pageSize: 4, pageSizes: false }}>
                        <ColumnsDirective>
                            <ColumnDirective field='markdate' headerText='Fecha de marcador' width='100'></ColumnDirective>
                            <ColumnDirective field='marklabel' headerText='Nombre de marcador' width='100'/>
                        </ColumnsDirective>
                    </GridComponent>
                </div>
            </div>);
    }

    /*rowselect(args) {
        let selRecord = args.data;
        let selecteMessage = document.getElementsByClassName('e-statustext')[0];
        let message = selecteMessage.querySelector('b');
        message.textContent = selRecord.ContactName;
        this.detailGrid.dataSource = data.filter((record) => record.CustomerName === selRecord.ContactName).slice(0, 5);
    }*/
        /*return (<div className='control-pane'>
                <div className='control-section'>
                    <GridComponent dataSource={this.master} selectedRowIndex={2} rowSelected={this.rowselect.bind(this)}>
                        <ColumnsDirective>
                            <ColumnDirective field='ContactName' headerText='Customer Name' width='150'></ColumnDirective>
                            <ColumnDirective field='CompanyName' headerText='Company Name' width='150'></ColumnDirective>
                            <ColumnDirective field='Address' headerText='Address' width='150'/>
                            <ColumnDirective field='Country' headerText='Country' width='130'/>
                        </ColumnsDirective>
                        <Inject services={[Selection]}/>
                    </GridComponent>

                    <div className='e-statustext'> Showing orders of Customer:  <b></b></div>

                    <GridComponent dataSource={this.detail} allowSelection={false} ref={grid => this.detailGrid = grid}>
                        <ColumnsDirective>
                            <ColumnDirective field='OrderID' headerText='Order ID' width='100'></ColumnDirective>
                            <ColumnDirective field='Freight' headerText='Freight' width='100' format='C2' type='number'/>
                            <ColumnDirective field='ShipName' headerText='Ship Name' width='150'></ColumnDirective>
                            <ColumnDirective field='ShipCountry' headerText='Ship Country' width='150'></ColumnDirective>
                            <ColumnDirective field='ShipAddress' headerText='Ship Address' width='150'></ColumnDirective>
                        </ColumnsDirective>
                    </GridComponent>
                </div>
            </div>);
    }*/
}

//render(<MasterDetail />, document.getElementById('sample'));